import React, { useState, useEffect, useMemo } from "react";
import BaseballView from "../view";
import BounceTransition from "components/transition/bounce";
import SportsTypeIcon from "components/sportsTypeIcon";
import OpacityTransition from "components/transition/opacity";
import SportsLoader from "components/sportsLoader";
import style from "../style.module.scss";
import useCommonStore from "hooks/useCommonStore";
import { observer } from "mobx-react";
import useStore from "../../../../hooks/useStore";
import Banner from "../../../../components/banner";
import { _SPORTS_TYPE } from "../../../../common/constants/sportsConstants";
import useUsersStore from "../../../../hooks/useUsersStore";

const BaseballWrapper = observer(
  ({
    loading,
    list,
    selectedGameList,
    selectedTab,
    selectedGames,
    setSelectedGame,
    scoreRef,
    resetParentFrame,
  }) => {
    const [initList, setInitList] = useState(false);
    const [sportsSelected, setSportsSelected] = useState([]);
    const [selectedList, setSelectedList] = useState([]);
    const [defaultList, setDefaultList] = useState([]);
    const { isAdminIP, openCaster } = useCommonStore();
    const { bannerStore } = useStore();
    const userStore = useUsersStore();

    useEffect(() => {
      userStore.getInfo();
    });

    useEffect(() => {
      if (!loading) {
        setSelectedList(selectedGameList);
        setDefaultList(list);
        setSportsSelected(selectedGames);
        setInitList(true);
        bannerStore.clearActiveMajorView();
        bannerStore.setSportType(_SPORTS_TYPE.BASEBALL);
      } else {
        setInitList(false);
      }
    }, [loading, list, selectedGameList, selectedGames]);

    useEffect(() => {
      resetParentFrame(scoreRef.current.scrollHeight);
    });

    const emptyListText = useMemo(() => {
      if (selectedTab === "ALL") {
        return "야구 경기 일정이 없습니다.";
      } else if (selectedTab === "READY") {
        return "대기중인 야구 경기가 없습니다.";
      } else if (selectedTab === "PROGRESS") {
        return "진행중인 야구 경기가 없습니다.";
      } else if (selectedTab === "FINAL") {
        return "금일 종료 경기가 없습니다.";
      }
    }, [selectedList, defaultList, selectedTab]);

    return (
      <div className="score_board_wrap">
        {initList ? (
          selectedList.length > 0 || defaultList.length > 0 ? (
            <>
              {selectedList.map((item, idx) => {
                return (
                  <BaseballView
                    key={`baseball-view-${item.id}`}
                    item={item}
                    isSelected={sportsSelected.some((id) => id.key === item.id)}
                    setSelectedGame={setSelectedGame}
                    isAdmin={isAdminIP && userStore.data.is_admin}
                    openCaster={openCaster}
                  />
                );
              })}
              {defaultList.map((item, idx) => {
                return (
                  <BaseballView
                    key={`baseball-view-${item.id}`}
                    item={item}
                    isSelected={sportsSelected.some((id) => id.key === item.id)}
                    setSelectedGame={setSelectedGame}
                    isAdmin={isAdminIP && userStore.data.is_admin}
                    openCaster={openCaster}
                  />
                );
              })}
            </>
          ) : (
            <>
              <Banner paddingTop="10px" paddingBottom="0" />
              <div className={style.livescore_empty}>
                <BounceTransition
                  loader={!loading}
                  duration={200}
                  type="bounce_in"
                >
                  <SportsTypeIcon
                    sportsType={"BASEBALL"}
                    height={40}
                    width={40}
                  />
                </BounceTransition>
                <OpacityTransition loader={!loading} duration={200}>
                  <h3>{emptyListText}</h3>
                </OpacityTransition>
                <OpacityTransition loader={!loading} duration={200} delay={100}>
                  <h5>
                    지난경기결과나 예정된 경기는 달력을 클릭하시면 편하게 찾아
                    보실 수 있습니다.
                  </h5>
                </OpacityTransition>
              </div>
            </>
          )
        ) : (
          <SportsLoader />
        )}

        {/*// score_board  */}
      </div>
    );
  }
);

export default BaseballWrapper;
